export const NETWORK_QUALITY = {
  GOOD: "GOOD",
  DEGRADED: "DEGRADED",
  POOR: "POOR",
  OFFLINE: "OFFLINE",
  UNKNOWN: "UNKNOWN",
};

const QUALITY_SEVERITY = {
  [NETWORK_QUALITY.UNKNOWN]: 0,
  [NETWORK_QUALITY.GOOD]: 1,
  [NETWORK_QUALITY.DEGRADED]: 2,
  [NETWORK_QUALITY.POOR]: 3,
  [NETWORK_QUALITY.OFFLINE]: 4,
};

const EFFECTIVE_TYPE_QUALITY = {
  "slow-2g": NETWORK_QUALITY.POOR,
  "2g": NETWORK_QUALITY.POOR,
  "3g": NETWORK_QUALITY.DEGRADED,
  "4g": NETWORK_QUALITY.GOOD,
};

const pickMoreSevere = (current, candidate) => {
  if (!candidate) {
    return current;
  }
  if (!current) {
    return candidate;
  }
  return QUALITY_SEVERITY[candidate] > QUALITY_SEVERITY[current]
    ? candidate
    : current;
};

const normalizeMetricQuality = ({ downlink, rtt }) => {
  let quality = null;
  const hasDownlink =
    typeof downlink === "number" && Number.isFinite(downlink) && downlink > 0;
  if (hasDownlink) {
    if (downlink < 1) {
      quality = NETWORK_QUALITY.POOR;
    } else if (downlink < 5) {
      quality = NETWORK_QUALITY.DEGRADED;
    } else {
      quality = NETWORK_QUALITY.GOOD;
    }
  }

  if (typeof rtt === "number") {
    let rttQuality;
    if (rtt > 800) {
      rttQuality = NETWORK_QUALITY.POOR;
    } else if (rtt > 400) {
      rttQuality = NETWORK_QUALITY.DEGRADED;
    } else {
      rttQuality = NETWORK_QUALITY.GOOD;
    }
    quality = pickMoreSevere(quality, rttQuality);
  }

  return quality;
};

export const normalizeNetworkQuality = ({
  online = true,
  effectiveType,
  downlink,
  rtt,
} = {}) => {
  if (online === false) {
    return {
      online: false,
      effectiveType,
      downlink,
      rtt,
      normalizedQuality: NETWORK_QUALITY.OFFLINE,
    };
  }

  let normalized = NETWORK_QUALITY.UNKNOWN;

  if (effectiveType && EFFECTIVE_TYPE_QUALITY[effectiveType]) {
    normalized = pickMoreSevere(
      normalized,
      EFFECTIVE_TYPE_QUALITY[effectiveType]
    );
  }

  const metricQuality = normalizeMetricQuality({ downlink, rtt });
  normalized = pickMoreSevere(normalized, metricQuality);

  return {
    online: online !== false,
    effectiveType,
    downlink,
    rtt,
    normalizedQuality: normalized,
  };
};

const NETWORK_QUALITY_MESSAGES = {
  [NETWORK_QUALITY.DEGRADED]:
    "Upload may take longer than usual due to a slow connection.",
  [NETWORK_QUALITY.POOR]:
    "Your connection appears weak. Upload may fail.",
  [NETWORK_QUALITY.OFFLINE]:
    "You appear to be offline. Upload cannot continue.",
};

export const getNetworkQualityMessage = (quality) =>
  (quality && NETWORK_QUALITY_MESSAGES[quality]) || null;

export const getNetworkQualitySeverity = (quality) => {
  if (quality === NETWORK_QUALITY.POOR || quality === NETWORK_QUALITY.OFFLINE) {
    return "danger";
  }
  if (quality === NETWORK_QUALITY.DEGRADED) {
    return "warning";
  }
  return null;
};
